<template>
    <vx-card title="Loan Sub-Category">
    <div id="user-edit-tab-info">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="vx-col w-full mb-base">
                    <template>
                        <vs-table stripe  max-items="8" pagination search :data="getAllLoanSubCategory"  >
                            
                            <template slot="thead">
                                <vs-th>Code</vs-th>
                                <vs-th>Description</vs-th>
                                <vs-th>Category</vs-th>
                                <vs-th>Action</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].loanSubCategoryCode">
                                        {{ data[indextr].loanSubCategoryCode }}
                                    </vs-td>
                                    <vs-td :data="data[indextr].loanSubCategoryName">
                                        {{ data[indextr].loanSubCategoryName }}
                                    </vs-td>
                                    <vs-td :data="data[indextr].loanCategoryId">
                                        {{ loanCategory(data[indextr].loanCategoryId).loanCategoryName }}
                                    </vs-td>
                                    
                                    <vs-td>
                                        <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" v-show="getDateDiff(data[indextr].createdOn) <= 10 ? true : false" >
                                            <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].loanSubCategoryId)" />
                                            <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].loanSubCategoryId)" />
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </template>
                </div>
            </div>
        </div>   
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-button type="gradient" color="primary" @click="promptAddNewRecord()"  icon-pack="feather" icon="icon-plus">Add</vs-button>
            </div>    
        </div>


    <!-- ADD LOAN SUB-CATEGORY -->
        <vs-prompt
            class="email-compose"
            title="Add Loan Sub-Category"
            accept-text= "Submit"
            @accept="onAddNewRecord"
            :is-valid="validForm"
            :active.sync="activePromptAddRecord">
            <vx-card title="Please fill-out the following information">
                <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Code</span> <span style="color:red">*</span>
                            <vs-input name="code" v-validate="'required'" class="w-full" v-model="loanSubCategory.loanSubCategoryCode" />
                            <span class="text-danger text-sm" v-show="errors.has('code')">{{ errors.first('code') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Description</span><span style="color:red">*</span>
                            <vs-input name="name" v-validate="'required'" class="w-full" v-model="loanSubCategory.loanSubCategoryName" />
                            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Category</span><span style="color:red">*</span>
                            <v-select name="loan category" v-validate="'required'" class="w-full" v-model="loanCategoryName" label="loanCategoryName" :options="getAllLoanCategory" placeholder="Please Select" />
                            <span class="text-danger text-sm" v-show="errors.has('loan category')">{{ errors.first('loan category') }}</span>
                        </div>
                    </div>
                   
                
            </vx-card>
        </vs-prompt>
    <!-- END ADD LOAN SUB-CATEGORY -->
    <!-- EDIT LOAN SUB-CATEGORY -->
        <vs-prompt
                  class="email-compose"
                  title="Edit Loan Sub-Category"
                  accept-text= "Submit"
                  @accept="onUpdateRecord"
                  :is-valid="validForm"
                  :active.sync="activePromptEditRecord">
                  <vx-card title="You may update the following information">
                  
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Code</span> <span style="color:red">*</span>
                            <vs-input name="code" v-validate="'required'" class="w-full" v-model="loanSubCategory.loanSubCategoryCode" />
                            <span class="text-danger text-sm" v-show="errors.has('code')">{{ errors.first('code') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Description</span><span style="color:red">*</span>
                            <vs-input name="name" v-validate="'required'" class="w-full" v-model="loanSubCategory.loanSubCategoryName" />
                            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Category</span><span style="color:red">*</span>
                            <v-select name="loan category" v-validate="'required'" class="w-full" v-model="loanCategoryName" label="loanCategoryName" :options="getAllLoanCategory" placeholder="Please Select" />
                            <span class="text-danger text-sm" v-show="errors.has('loan category')">{{ errors.first('loan category') }}</span>
                        </div>
                    </div>

                  </vx-card>
              </vs-prompt>
    <!-- END EDIT EARNINGS -->
   </div>          
    </vx-card>     
</template>
<script>

import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Swal from 'sweetalert2'
export default {
    data() {
        return {
            loanSubCategory: {
                loanSubCategoryCode: '',
                loanSubCategoryName: '',
                loanCategoryId: 1,
            },
            activePromptAddRecord: false,
            activePromptEditRecord: false

        }
    },
    created() {
        this.$store.dispatch('lookup/getAllLoanCategory').catch((err) => { console.log(err)})
        this.$store.dispatch('lookup/getAllLoanSubCategory').catch((err) => { console.log(err)})
      
    },
    components: {
         'v-select': vSelect,
        Datepicker,
        flatPickr,
    },
    computed: {
        getAllLoanCategory() {
            return this.$store.state.lookup.loanCategory
        },
        getAllLoanSubCategory() {
            return this.$store.state.lookup.loanSubCategory
        },
        getAllDeductionsCategory() {
            return this.$store.state.lookup.getAllDeductionsCategory
        },
        loanCategoryName: {
            get() { return this.$store.getters['lookup/loanCategoryLookup'](this.loanSubCategory.loanCategoryId) },
            set(obj) { this.loanSubCategory.loanCategoryId = obj.loanCategoryId }
        },
        loanCategory() {
            return (id) => this.$store.getters['lookup/loanCategoryLookup'](id) 
        },
       
        validForm() {

        },
        getDateDiff(){
            return (createdOn) => {
                var oneDay = 1
                if (createdOn !== null && this.currentDate !== null) {
                        var date1 = new Date(moment(createdOn).format("MM-DD-YYYY"))
                        var date2 = new Date(moment(this.currentDate).format("MM-DD-YYYY"))

                        var timeDiff = Math.abs(date2.getTime() - date1.getTime())
                        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
                        if (diffDays !== 'NaN') {
                           return diffDays + oneDay  
                        } else { return 0 }
                }
            }

        },
        
    },
    methods: {
        promptAddNewRecord() {
            this.activePromptAddRecord = true
        },
        onAddNewRecord() {
            this.$vs.loading()
            this.$store.dispatch('lookup/addLoanSubCategory', this.loanSubCategory)
                .then((response) => {
                    this.$vs.loading.close()
                    if(response.status == 200)
                        this.$alert("", 'Save Successfully', "success")
                })
                .catch((error) => {
                    this.$vs.loading.close()
                    this.$alert(error, 'Error', "error")
                })
        },
        editRecord(id) {
            

            const e = this.$store.getters['lookup/loanSubCategoryLookup'](id)
            
            this.loanSubCategory.loanSubCategoryId = id,
            this.loanSubCategory.loanSubCategoryCode = e.loanSubCategoryCode,
            this.loanSubCategory.loanSubCategoryName = e.loanSubCategoryName
            this.loanSubCategory.loanCategoryId = e.loanCategoryId,
           

            this.activePromptEditRecord = true
        },
        onUpdateRecord() {
            this.$vs.loading()
            this.$store.dispatch('lookup/updateLoanSubCategory', this.loanSubCategory)
                .then((response) => {
                    this.$vs.loading.close()
                    if(response.status == 200)
                        this.$alert("", 'Updated Successfully', "success")
                })
                .catch((error) => {
                    this.$vs.loading.close()
                    this.$alert(error, 'Error', "error")
                })
        },
        confirmDeleteRecord(id) {
             Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text: "",
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Confirm',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$vs.loading()
                    this.$store.dispatch('lookup/deleteLoanSubCategory', id)
                        .then((response) => {
                            this.$vs.loading.close()
                            if(response.status == 200) {
                                this.$alert("", 'Deleted Successfully', "success")
                            }
                                
                        })
                        .catch((error) => {
                            this.$vs.loading.close()
                            this.$alert(error, 'Error', "error")
                        })
                } else
                    this.$alert("", 'Cancelled Delete', "success")
            })
            
        }
    }
       
}
</script>